import { translate } from '../App/Internationalization';

export const ScoreTiers = {
	All: translate('global.mover_score_tiers.all'),
	High: translate('global.mover_score_tiers.high'),
	Medium: translate('global.mover_score_tiers.medium'),
	// eslint-disable-next-line sort-keys -- no need to sort
	Low: translate('global.mover_score_tiers.low'),
	NotApplicable: translate('global.mover_score_tiers.not_applicable'),
};
